
export const TRIP_HEADER_TEST_ID = {
  BACK_ICON: 'listingPage_header_backIcon', // FIXME: we are using 'listing' due to legacy reasons,
  EDIT_BUTTON: 'listingPage_header_editIcon',
  TITLE: 'listingPage_header_title',
  SUBTITLE: 'listingPage_header_subtitle',
};
